import { instanceOf, object, oneOfType, shape, string } from "prop-types";

export const DOCX_PREVIEW_ID = "vt_docx_page";
export const DOCX_PREVIEW_STYLES_ID = "vt_docx_preview_styles";

export const DOX_ID_PREFIX = "vt_document_viewer_paragraph_";
export const PAGE_ID_PREFIX = "vt_document_viewer_page_";

export const PAGE_INTRO_LIMIT = 150;

export const HIGHLIGHT_WAIT_TIMEOUT_MS = 10000;
export const ROW_MOUNT_GRACE_MS = 1500;
export const PDF_PAGE_SPINNER_DELAY_MS = 1000;

export const REMOVE_STYLE_ATTR_REGEX = /style="[^"]+"/g;

export const A4_WIDTH_72DPI = 595;
export const A4_HEIGHT_72DPI = 842;
export const PDF_PAGE_GAP_PX = 16;
export const SCROLLBAR_DITHER = 10;

export const FILE_PROP_TYPE = oneOfType([
  shape({
    url: string,
    headers: object,
  }),
  instanceOf(File),
]);
